export default __webpack_public_path__ + "static/media/changelog.b654fc6e.md";